import { createContext } from "react"

const UserContext = createContext({ user: {}, onChange: () => {} })

export default UserContext
